import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { HpUploadIcon } from "@/themes/hp-client/icons";
import { useTheme } from "@/contexts/theme";

const UploadIcon = (props: any) => {
  const { primaryColor } = useGomakeTheme();
  const strokeColor = props.color || primaryColor(300);
  const { currentTheme } = useTheme();
  if (currentTheme === "hp-client") {
    return (
      <HpUploadIcon
        color={props?.color ?? "#1A1A1A"}
        width={props?.width ?? 24}
        height={props?.height ?? 24}
      />
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 16}
      height={props?.height ?? 16}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-upload-icon lucide-upload"
    >
      <path d="M12 3v12" />
      <path d="m17 8-5-5-5 5" />
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    </svg>
  );
};

export { UploadIcon };
